<template>
  <li
    class="videoItem"
    @click="toVideoPlayer(videoId)">
    <div class="videoItem-pic">
      <base-image
        class="videoItem-pic-img"
        encrypt
        :ratio="360/203"
        :url="img.url"
        :type="img.type" />
    </div>
    <div class="videoItem-content">
      <div class="videoItem-content-title">{{ title }}</div>
      <div class="videoItem-content-tags">
        <button
          v-for="tag of tags"
          :key="tag.id"
          class="videoItem-content-tags-tag"
          @click.stop="$emit('click-tag', { title: tag.name, id: tag.id })">{{ tag.name }}</button>
      </div>
      <div class="videoItem-content-views">
        <span class="videoItem-content-views-number">{{ (views / 10000).toFixed(2) }}</span>万次播放
      </div>
    </div>
  </li>
</template>

<script>
import baseImage from '@/components/baseImage'
export default {
  name: 'VideoItem',
  components: {
    baseImage
  },
  props: {
    videoId: {
      type: Number,
      required: true
    },

    img: {
      type: Object,
      default: () => ({
        type: '',
        url: ''
      })
    },

    title: {
      type: String,
      required: true
    },

    tags: {
      type: Array,
      default: () => ([])
    },

    views: {
      type: Number,
      required: true
    }
  },
  methods: {
    toVideoPlayer (videoId) {
      this.$router.push({
        path: 'playLink',
        query: {
          id: videoId
        }
      })
    }
  }
}
</script>

<style scoped>
.videoItem {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
  padding: 15px 0;
}

.videoItem::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 1px;
  content: "";
  background: rgba(51, 51, 51, 1);
}

.videoItem-pic {
  width: 40%;
  border-radius: 4px;
}

.videoItem-pic-img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
  object-fit: cover;
}

.videoItem-content {
  width: 58%;
}

.videoItem-content-title {
  width: 100%;
  overflow: hidden;
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.videoItem-content-tags {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 27px;
  margin: 8px 0;
  overflow: hidden;
}

.videoItem-content-tags-tag {
  box-sizing: border-box;
  padding: 5px 10px;
  margin: 0 5px 0 0;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  background: rgba(68, 68, 68, 1);
  border: none;
  border-radius: 20px;
}

.videoItem-content-views {
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  color: #ccc;
  text-align: left;
}

.videoItem-content-views-number {
  color: #eab87f;
}

</style>



// WEBPACK FOOTER //
// src/components/VideoItem.vue